'use strict';

const { h } = require('phy');

function OfferAdvertImage({
  className = '',
  alt,
  data = [],
  size = [],
  lazy = true,
}) {
  const media = data && data[0];

  if (!media) return null;

  const src = media.mediaUrl
    ? media.mediaUrl.replace('{{options}}', `${size[0]},`)
    : '';

  const lazyAttributes = lazy
    ? {
        class: `lazy-load no-bg ${className}`,
        'data-src': src,
        src:
          'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      }
    : {
        class: className,
        src,
      };

  return (
    media.mediaUrl &&
    h('img', {
      ...lazyAttributes,
      alt,
    })
  );
}

module.exports = OfferAdvertImage;
